import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Address} from 'types/order';
import AddressForm from './AddressForm';
import styles from './UserAddresses.module.scss';
import {capitalize} from 'lodash';
import Typography from 'components/Typography';
import ArrowIcon from './ArrowIcon';
import Button from 'components/Button';

import ListWrapper from 'components/ListWrapper';

type AddressEntity = Address & {id: number};

type UserAddressesProps = {
  addresses: AddressEntity[];
  onSave: () => void;
  isShow: boolean;
  deleting: boolean;
  userId: number;
  onChange: (valud: AddressEntity[]) => void;
  setAddressModalVisible: (val: boolean) => void;
  refetch: () => void;
};

export const labels = [
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const UserAddresses: React.FC<UserAddressesProps> = ({
  addresses = [],
  onSave,
  deleting,
  isShow,
  setAddressModalVisible,
  onChange,
}) => {
  const [expandedId, setExpandedId] = useState<number[]>([]);
  const [changedAddresses, setChangedAddresses] = useState<AddressEntity[]>([]);

  const handleChange = useCallback(
    (address: AddressEntity) => {
      const savedEntity = changedAddresses.find(
        (item) => item.id === address.id
      );
      if (savedEntity) {
        setChangedAddresses((prev) =>
          prev.map((item) =>
            item.id === savedEntity.id ? {...savedEntity, ...address} : item
          )
        );
      } else {
        setChangedAddresses((prev) => [...prev, address]);
      }
    },
    [changedAddresses]
  );
  useEffect(() => {
    if (addresses?.length > 0) {
      setExpandedId([addresses[0].id]);
    }
  }, [addresses]);
  useEffect(() => {
    onChange(changedAddresses);
  }, [changedAddresses, onChange]);

  const deleteRef = useRef(0);

  if (!isShow) {
    return null;
  }
  return (
    <div>
      <ListWrapper className={styles.list_wrapper}>
        <div className={styles.accordion}>
          <div className={styles.accordion__inner}>
            <Typography variant="h3" className={styles.accordion__title}>
              Addresses
            </Typography>
            {addresses.map((address) => (
              <div className={styles.accordion__item} key={address.id}>
                <div
                  className={styles.accordion__item_header}
                  onClick={() =>
                    expandedId.includes(address.id)
                      ? setExpandedId((pr) =>
                          pr.filter((item) => item !== address.id)
                        )
                      : setExpandedId((pr) => [...pr, address.id])
                  }
                >
                  <ArrowIcon
                    className={
                      expandedId.includes(address.id)
                        ? styles.accordion__item_header_icon_rotated
                        : ''
                    }
                  />{' '}
                  {address.type === 'home'
                    ? 'Home or work'
                    : capitalize(address.type)}
                </div>
                {expandedId.includes(address.id) && (
                  <div className={styles.accordion__item_content}>
                    <AddressForm
                      defaultValues={address}
                      deleting={deleting && address.id === deleteRef.current}
                      onSave={() => {
                        deleteRef.current = address.id;
                        onSave();
                      }}
                      onChange={(add: any) => {
                        handleChange({...add, id: address.id});
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={styles.actionWrapper}>
            <Button
              style={{
                backgroundColor: '#fff',
              }}
              onClick={() => setAddressModalVisible(true)}
            >
              Add New Address
            </Button>
          </div>
        </div>
      </ListWrapper>
    </div>
  );
};

export default UserAddresses;
